// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  assetsInfoEntityAdapter,
  classificationsAdapter,
  initialState,
  ratesAdapter,
} from './assets-repository-state';
import type {
  AssetsInfoState,
  ClassificationsState,
  ExchangeRatesState,
} from '@shared/data-access/interfaces/redux/assets-repository-state-types';

export const assetsRepositorySlice = createSlice({
  initialState: () => initialState,
  name: 'assetsRepository',
  reducers: {
    reset: () => initialState,
    upsertAssetInfo: (
      state,
      { payload }: PayloadAction<Array<AssetsInfoState>>,
    ) => {
      assetsInfoEntityAdapter.upsertMany(state.assets, payload);
    },
    syncRates: (state, action: PayloadAction<Array<ExchangeRatesState>>) => {
      ratesAdapter.upsertMany(state.exchangeRates, action.payload);
    },
    upsertClassifications: (
      state,
      action: PayloadAction<Array<ClassificationsState>>,
    ) => {
      classificationsAdapter.upsertMany(state.classifications, action.payload);
    },
  },
  extraReducers: () => {
    return;
  },
});
